import { useNavigate, useParams } from "react-router-dom";
import FormPage from "../../components/forms/FormPage";
import useUserEnumController from "../../controllers/edit/codesEditController";
import { useEffect } from "react";
import FormTextField from "../../components/forms/fields/basic/TextField";
import FormMultiTextField from "../../components/forms/fields/basic/MultiTextInput";

const EditCodePage: React.FC = () => {
  const { _id = null } = useParams<{ _id?: string }>();
  if (!_id) {
    throw new Error("UserEnum ID is required for editing.");
  }

  const navigate = useNavigate();
  const controller = useUserEnumController(_id);

  useEffect(() => {
    if (typeof _id !== "string" || _id.trim() === "") {
      navigate("/not-found", { replace: true });
    }
  }, [_id, navigate]);

  if (typeof _id !== "string" || _id.trim() === "") return null;

  return (
    <FormPage controller={controller}>
      <FormTextField name="name" label="Name" static />
      <FormMultiTextField name="values" label="Values" required placeholder="Value"/>
    </FormPage>
  );
};

export default EditCodePage;
